module.exports = __webpack_public_path__ + "img/4-1-2-2-preview-routemap-c.fee36281.jpg";